import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../config/config.js';

function Tours({ tours }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [selectedTourTypes, setSelectedTourTypes] = useState([]);
  const [priceRange, setPriceRange] = useState([130, 800]);
  const [sidebarData, setSidebarData] = useState({
    categories: [],
    activities: [],
    tourTypes: [],
  });
  const itemsPerPage = 6;

  useEffect(() => {
    const fetchSidebarData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/tour-package/sidebar-data`);
        const data = await response.json();
        setSidebarData(data.data || { categories: [], activities: [], tourTypes: [] });
      } catch (error) {
        console.error("Error fetching sidebar data:", error);
      }
    };

    fetchSidebarData();
  }, []);

  const handleCategoryChange = (e) => {
    const { value, checked } = e.target;
    setSelectedCategories((prev) =>
      checked ? [...prev, value] : prev.filter((item) => item !== value)
    );
  };

  const handleActivityChange = (e) => {
    const { value, checked } = e.target;
    setSelectedActivities((prev) =>
      checked ? [...prev, value] : prev.filter((item) => item !== value)
    );
  };

  const handleTourTypeChange = (e) => {
    const { value, checked } = e.target;
    setSelectedTourTypes((prev) =>
      checked ? [...prev, value] : prev.filter((item) => item !== value)
    );
  };

  const handlePriceChange = (e) => {
    const { id, value } = e.target;
    setPriceRange((prev) =>
      id === 'min-slider' ? [parseInt(value), prev[1]] : [prev[0], parseInt(value)]
    );
  };

  const filteredTours = tours.filter((tour) => {
    const matchesPrice = tour.price >= priceRange[0] && tour.price <= priceRange[1];
    const matchesCategory = selectedCategories.length === 0 || selectedCategories.some((cat) =>
      tour.destinations.includes(cat)
    );
    const matchesActivity = selectedActivities.length === 0 || selectedActivities.some((act) =>
      tour.category?.toLowerCase().includes(act.toLowerCase()) || tour.title.toLowerCase().includes(act.toLowerCase())
    );
    const matchesTourType = selectedTourTypes.length === 0 || selectedTourTypes.some((type) =>
      tour.title.toLowerCase().includes(type.toLowerCase()) || tour.package_type?.toLowerCase().includes(type.toLowerCase())
    );
    return matchesPrice && matchesCategory && matchesActivity && matchesTourType;
  });

  const totalPages = Math.ceil(filteredTours.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentTours = filteredTours.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="tour-section section-padding fix">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-8">
            <div className="tour-wrapper">
              <div className="row g-4">
                {currentTours.map((tour, index) => (
                  <div
                    className="col-md-6 wow fadeInUp"
                    data-wow-delay={`.${(index % 3) * 3 + 2}s`}
                    key={tour.id}
                  >
                    <div className="destination-card-items style-2">
                      <div className="destination-thumb">
                        <img src={tour.image} alt={tour.title} />
                        <div className="ratting">
                          <i className="fa-solid fa-star"></i>
                          <span>{tour.average_rating || 'N/A'}</span>
                        </div>
                        <div className="heart">
                          <i className="fa-solid fa-heart"></i>
                        </div>
                      </div>
                      <div className="destination-content">
                        <h4>
                          <Link to={`/tour-package-details?category=${tour.category}&value=${tour.value}`}>
                            {tour.title}
                          </Link>
                        </h4>
                        <span className="place">
                          <i className="fa-solid fa-location-dot"></i>{" "}
                          {tour.destinations.join(', ')}
                        </span>
                        <h5>
                          ${tour.price.toFixed(2)}<span>/Person</span>
                        </h5>
                        <div className="booking">
                          <span>
                            <i className="fa-solid fa-clock"></i> {tour.duration}
                          </span>
                          <Link
                            to={`/tour-package-details?category=${tour.category}&value=${tour.value}`}
                            className="theme-btn"
                          >
                            Read More{" "}
                            <img src="assets/img/icon/theme-arrow.svg" alt="arrow" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="page-nav-wrap">
              <ul>
                {[...Array(totalPages)].map((_, index) => (
                  <li key={index + 1} className={currentPage === index + 1 ? 'active' : ''}>
                    <Link
                      to="#"
                      className="page-numbers"
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {String(index + 1).padStart(2, '0')}
                    </Link>
                  </li>
                ))}
                {currentPage < totalPages && (
                  <li>
                    <Link
                      to="#"
                      className="page-numbers"
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      <i className="fal fa-long-arrow-right"></i>
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="main-sidebar mt-0">
              <div className="single-sidebar-widget">
                <div className="wid-title">
                  <h3>Destination Category</h3>
                </div>
                <div className="categories-list">
                  {sidebarData.categories.map((category) => (
                    <label
                      className="checkbox-single d-flex justify-content-between align-items-center"
                      key={category.name}
                    >
                      <span className="d-flex gap-xl-3 gap-2 align-items-center">
                        <span className="checkbox-area d-center">
                          <input
                            type="checkbox"
                            value={category.name}
                            onChange={handleCategoryChange}
                            checked={selectedCategories.includes(category.name)}
                          />
                          <span className="checkmark d-center"></span>
                        </span>
                        <span className="text-color">{category.name}</span>
                      </span>
                      <span className="text-color">{category.count}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div className="single-sidebar-widget">
                <div className="wid-title style-2">
                  <h3>Destination</h3>
                  <i className="fa-solid fa-chevron-down"></i>
                </div>
                <div className="price-range-wrapper">
                  <div className="slider-container">
                    <input
                      type="range"
                      id="min-slider"
                      className="slider"
                      min="130"
                      max="800"
                      value={priceRange[0]}
                      onChange={handlePriceChange}
                    />
                    <input
                      type="range"
                      id="max-slider"
                      className="slider"
                      min="130"
                      max="800"
                      value={priceRange[1]}
                      onChange={handlePriceChange}
                    />
                  </div>
                  <div className="price-text pt-4 d-flex gap-3">
                    <label htmlFor="amount">Price:</label>
                    <input
                      type="text"
                      id="amount"
                      readOnly
                      style={{ border: 0 }}
                      value={`$${priceRange[0]} - $${priceRange[1]}`}
                    />
                  </div>
                </div>
              </div>
              <div className="single-sidebar-widget">
                <div className="wid-title">
                  <h3>Activities</h3>
                </div>
                <div className="categories-list">
                  {sidebarData.activities.map((activity) => (
                    <label
                      className="checkbox-single d-flex justify-content-between align-items-center"
                      key={activity.name}
                    >
                      <span className="d-flex gap-xl-3 gap-2 align-items-center">
                        <span className="checkbox-area d-center">
                          <input
                            type="checkbox"
                            value={activity.name}
                            onChange={handleActivityChange}
                            checked={selectedActivities.includes(activity.name)}
                          />
                          <span className="checkmark d-center"></span>
                        </span>
                        <span className="text-color">{activity.name}</span>
                      </span>
                      <span className="text-color">{activity.count}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div className="single-sidebar-widget">
                <div className="wid-title style-2">
                  <h3>Tour Types</h3>
                  <i className="fa-solid fa-chevron-down"></i>
                </div>
                <div className="categories-list">
                  {sidebarData.tourTypes.map((type) => (
                    <label
                      className="checkbox-single d-flex justify-content-between align-items-center"
                      key={type.name}
                    >
                      <span className="d-flex gap-xl-3 gap-2 align-items-center">
                        <span className="checkbox-area d-center">
                          <input
                            type="checkbox"
                            value={type.name}
                            onChange={handleTourTypeChange}
                            checked={selectedTourTypes.includes(type.name)}
                          />
                          <span className="checkmark d-center"></span>
                        </span>
                        <span className="text-color">{type.name}</span>
                      </span>
                      <span className="text-color">{type.count}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Tours;